import { getHasSeen } from './get-has-seen';
import { setHasSeen } from './set-has-seen';

export const actions = {
	getHasSeen,
	setHasSeen,
} as const;
